
import React from "react";
import mergeObject from "@gqlapp/utils/merge/mergeObject";
import redirectTo from '@lib/redirect';
import ROUTER from './graphql/Route.graphql';
import getRoute from './classes/RouteOperations';
import { getItem } from "@gqlapp/core-common/clientStorage";
import clientModules from '@lib/clients';
import { cleanPath } from '@lib/content/normalize';
import { fetchMenu } from '@lib/content/fetch';

(async () => await clientModules.createApp(module))();
/**
 * Default Page
 * @param props
 * @constructor
 */
export default function Page(props: any){
	// @ts-ignore
	return React.createElement(clientModules.router, props)
}

/**
 * getInitialProps
 * @param load
 * @param route_type
 * @param apolloClient
 * @param asPath
 * @param path
 * @param headers
 * @param query
 * @param ctx
 */
export const getInitialProps = async (
	{ load, route_type, apolloClient, asPath, path, headers, query, ...ctx }: any  & { route_type: string } = {}
)=>{
	let start_time = (new Date()).getTime(), runtimejs = false, type_name: string, graphqlRoute: any = {}, session: any = {}, localKey: string;
	let	currentUser: any, redirect: string, site: string, currency: any, firebaseSettings: any;
	let history: any = [], pathLast: any, cookiePaths: any;
	if(isTrue('DEBUG')){
		error('getInitialProps', start_time)
	}
	path = path || '/';

	let pathto = path.replace('/dashboard', '/');

	ctx = mergeObject({ headers, apolloClient, path, asPath, query }, ctx );

	try{
		if(!__SERVER__){
			cookiePaths = getCookie('history', ctx)
			if(cookiePaths){ history = JSON.parse(cookiePaths); }
			history = history || [];
		}

		try{ pathLast = [...history].at(-1) }catch (e) {}

		if(pathLast !== pathto){
			history.push(pathto);
		}

		history = [...history.slice(-5)]

		setCookie('history', JSON.stringify(history), __SERVER__ ? { req: ctx?.req, res: ctx?.res }: null);
		Object.assign(ctx, { history });

	}catch (e) {
		debug('##### error ####', e)
	}


	const routePath = cleanPath(path);

	try {
		/** Load du lieu website cung voi cookie */
		const result = await getRoute({ variables: { path: routePath }})(apolloClient);

		if(isTrue('DEBUG'))  debug('######withRouteContainer',{ result, route_type })
		let data: any = result?.data || {};

		try{ await apolloClient.writeQuery({ query: ROUTER, data, variables: { path: routePath }}); }catch (e) { debug(e) }

		/** Set variable */
		currentUser = data?.currentUser || {};
		site = data?.site || {};
		session = data?.session || {};
		localKey = data?.localkey;
		currency = data?.currency;

		firebaseSettings = data?.site?.firebase || {}
		/*** The variable has been set */

		if(data?.res?.runtimejs) runtimejs = true;

		/** * Checked load database */
		if(load){
			graphqlRoute = data?.res || {};
			type_name = graphqlRoute?.type_name;
			if(type_name === 'TypeIsRedirect' && graphqlRoute?.title){
				redirect = graphqlRoute?.title;
			}
		}
	}catch (e) {
		debug(path, e)
	}

	// debug('######graphqlRoute', load, graphqlRoute)
	route_type = route_type || type_name;

	/*** redirect from getInitialProps */
	if(type_name === 'TypeIsRedirect' && redirect && redirect !== path){
		redirectTo(redirect, ctx);
	}

	/** get route_type **/
	clientModules.props = { route_type, path };
	(clientModules.typeByRoute) && (route_type = clientModules.typeByRoute);

	if(isTrue('DEBUG')) debug('######withRoute', 'getInitialProps', { route_type, type_name, query })

	let mainMenu: any[] = [];
	try { mainMenu = await fetchMenu(apolloClient, 'main'); } catch (e) { debug(e); }

	try{ const preUrl = await getItem('location'); ctx = mergeObject({ preUrl }, ctx); }catch (e) { debug(e); }
	ctx = mergeObject({ localKey, session, site, currency, firebaseSettings, currentUser, headers, graphqlRoute, route_type, mainMenu }, ctx)
	try{
		let routeProps: any = clientModules.getRouteProps;

		if(routeProps){
			const { perms, redirectOnLoggedIn, redirectOnAnonymous, redirect: to = '/' } = routeProps || {};
			if(routeProps?.runtimejs) runtimejs = true;

			ctx = mergeObject({ runtimejs, start_time }, ctx);

			/**
			 * check type of page
			 */
			
			// if(isTrue('DEBUG')) {
			// 	debug('######page', 'getInitialProps', routeProps.getInitialProps);
			// }

			/*** */
			(routeProps.getInitialProps) && (ctx = mergeObject(await routeProps.getInitialProps(ctx), ctx));
		}

	}catch (e) {
		console.error(e)
	}

	return ctx;
}
